export default class MapZoomRulesUtils {
  static hideMaintainers(zoom: number): boolean {
    return zoom < 10;
  }

  static hidePOI(zoom: number): boolean {
    return zoom < 13;
  }

  static includeRouteSegments(zoom: number): boolean {
    return zoom >= 11;
  }

  static getMaxBins(zoom: number): number {
    if (zoom >= 16) return 500; // street level - full detail
    if (zoom >= 13) return 300; // neighborhood
    if (zoom >= 10) return 150; // city level
    if (zoom >= 7) return 75; // region level
    if (zoom >= 4) return 30; // country level
    return 10; // continent / world
  }

  static getSearchRadius(zoom: number): number {
    if (zoom >= 13) return 1500;
    if (zoom >= 10) return 3000;
    if (zoom >= 7) return 6000;
    return 10000;
  }
}
